import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { getStrandsFromTags } from '../../helpers/utils';
import { MODULE_NAME_ACTIVITY } from '../../helpers/constants';

export const PageTitle = () => {
  const { initMleReducer } = useSelector(state => state);
  const activityMetaData = (initMleReducer.find(item => item.meta.name === MODULE_NAME_ACTIVITY) || {}).meta;
  const { tags, user: { locale } = {} } = activityMetaData || {};
  const { strand, subStrand } = getStrandsFromTags(tags, locale);

  return (
    <Helmet>
      {
        initMleReducer.length > 0 && (
          <title>{`${strand ? `${strand}${subStrand ? `: ${subStrand}` : ''} - ` : ''}Challenges - Mathletics`}</title>
        )
      }
    </Helmet>
  );
};
